export const LOAD_SUBSCRIPTION_PREFERENCES_BEGIN = 'LOAD_SUBSCRIPTION_PREFERENCES_BEGIN';
export const LOAD_SUBSCRIPTION_PREFERENCES_ERROR = 'LOAD_SUBSCRIPTION_PREFERENCES_ERROR';
export const LOAD_SUBSCRIPTION_PREFERENCES_SUCCESS = 'LOAD_SUBSCRIPTION_PREFERENCES_SUCCESS';
